
import 'components/autocomplete.tag'
import 'components/datetime-picker.tag'
import 'components/loader.tag'
import 'components/catalog.tag'
import 'pages/images/images-gallery-modal.tag'
riot.tag2('stock-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#orders/stock"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;stock&quot;, &quot;0100&quot;) : checkPermission(&quot;stock&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? \'Новая партия\' : \'Редактирование партии № \' + item.id}</div>\n    <div id="stock-edit-home">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-1" if="{!isNew}">\n            <div class="form-group">\n              <label class="control-label">Ид</label>\n              <input class="form-control" name="id" value="{item.id}" readonly>\n            </div>\n          </div>\n          <div class="col-md-2" if="{!isNew}">\n            <div class="form-group">\n              <label class="control-label">Дата партии</label>\n              <datetime-picker class="form-control" name="date" format="YYYY-MM-DD" value="{item.date}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="well well-sm">\n              <h4>Заказы</h4>\n              <catalog-static name="orders" rows="{item.orders}" cols="{orderCols}" remove="true" handlers="{handlers}" dblclick="{handlers.orderItemsShow}">\n                <yield to="toolbar">\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllSent}" onchange="{opts.handlers.isAllSentClick}">Отправлен\n                  </label>\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllChecked}" onchange="{opts.handlers.isAllCheckedClick}">Проверен\n                  </label>\n                  <label class="checkbox-inline pull-right" style="width:10%;">\n                    <input type="checkbox" __checked="{parent.isAllCollected}" onchange="{opts.handlers.isAllCollectedClick}">Собран\n                  </label>\n                </yield>\n                <yield to="body">\n                  <datatable-cell name="idOrder"><a class="open-page-item" href="#orders/{row.idOrder}" target="_blank">{row.idOrder}</a></datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="track" style="width: 20%;">\n                    <input class="form-control" if="{row.isSent}" value="{row.track}" type="text" onchange="{handlers.stringChange}">\n                  </datatable-cell>\n                  <datatable-cell name="image">\n                    <button class="btn btn-sm btn-success" if="{row.isCollected}" onclick="{handlers.imageEdit}"><i class="fa fa-picture-o"></i></button>\n                  </datatable-cell>\n                  <datatable-cell name="email">{row.email}</datatable-cell>\n                  <datatable-cell name="customer">{row.nameRecipient}</datatable-cell>\n                  <datatable-cell name="isCollected" style="width:10%;"><i class="fa fa-fw {row.isCollected ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isCollectedClick}"></i></datatable-cell>\n                  <datatable-cell name="isChecked" style="width:10%;"><i class="fa fa-fw {row.isChecked ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.isCollected}" onclick="{handlers.isCheckedClick}"></i></datatable-cell>\n                  <datatable-cell name="isSent" style="width:10%;"><i class="fa fa-fw {row.isSent ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" if="{row.isCollected}" onclick="{handlers.isSentClick}"></i></datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="well well-sm">\n              <h4>Наличие на складе</h4>\n              <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove-toolbar="1" handlers="{handlers}">\n                <yield to="body">\n                  <datatable-cell name="article">{row.article}</datatable-cell>\n                  <datatable-cell name="name">{row.name}</datatable-cell>\n                  <datatable-cell name="count">{row.count}</datatable-cell>\n                  <datatable-cell name="stock">{row.stock}</datatable-cell>\n                  <datatable-cell class="{bg-danger: row.stock &lt; row.count}" name="result">{row.stock - row.count}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Примечание администратора</label>\n              <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.isNew = false;
self.item = {};
self.loader = false;

self.isAllCollected = false;
self.isAllChecked = false;
self.isAllSent = false;

self.orderCols = [{ name: 'idOrder', value: '#' }, { name: 'dateOrder', value: 'Дата' }, { name: 'track', value: 'Трек номер' }, { name: 'image', value: 'Фото' }, { name: 'email', value: 'Заказчик' }, { name: 'customer', value: 'ФИО' }, { name: 'isCollected', value: 'Собран' }, { name: 'isChecked', value: 'Проверен' }, { name: 'isSent', value: 'Отправлен' }];

self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'В заказах' }, { name: 'stock', value: 'На складе' }, { name: 'result', value: 'Результат' }];

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = {
    id: 'empty'
};

observable.on('stock-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.update();

    API.request({
        object: 'Stock',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.item = response;
            self.loader = false;
            self.update();
        }
    });
});

self.checkAll = function () {
    var cntColl = 0,
        cntCkeck = 0,
        cntSent = 0;

    if (self.item && self.item.orders) {
        self.item.orders.forEach(function (order) {
            cntColl += order.isCollected;
            cntCkeck += order.isChecked;
            cntSent += order.isSent;
        });

        self.isAllCollected = cntColl == self.item.orders.length && cntColl > 0;
        self.isAllChecked = cntCkeck == cntColl && cntCkeck > 0;
        self.isAllSent = cntSent == cntColl && cntSent > 0;
    }
};

self.on('update', function () {
    self.checkAll();
});

self.handlers = {
    stringChange: function stringChange(e) {
        this.row[this.opts.name] = e.target.value;
    },
    isAllCollectedClick: function isAllCollectedClick() {
        if (self.item && self.item.orders) {
            self.item.orders.forEach(function (order, i) {
                if (self.isAllCollected) {
                    self.item.orders[i].isCollected = 0;
                    self.item.orders[i].isChecked = 0;
                    self.item.orders[i].isSent = 0;
                } else {
                    self.item.orders[i].isCollected = 1;
                }
            });
        }

        self.checkAll();
    },
    isAllCheckedClick: function isAllCheckedClick() {
        if (self.item && self.item.orders) {
            self.item.orders.forEach(function (order, i) {
                if (self.isAllChecked) {
                    self.item.orders[i].isChecked = 0;
                } else {
                    if (order.isCollected) {
                        self.item.orders[i].isChecked = 1;
                    }
                }
            });
        }

        self.checkAll();
    },
    isAllSentClick: function isAllSentClick() {
        if (self.item && self.item.orders) {
            self.item.orders.forEach(function (order, i) {
                if (self.isAllSent) {
                    self.item.orders[i].isSent = 0;
                } else {
                    if (order.isCollected) {
                        self.item.orders[i].isSent = 1;
                    }
                }
            });
        }

        self.checkAll();
    },
    isCollectedClick: function isCollectedClick(e) {
        e.item.row.isCollected = !e.item.row.isCollected;
        e.item.row.isChecked = 0;
        e.item.row.isSent = 0;
        self.checkAll();
    },
    isCheckedClick: function isCheckedClick(e) {
        e.item.row.isChecked = !e.item.row.isChecked;
        //e.item.row.isSent = 0
        self.checkAll();
    },
    isSentClick: function isSentClick(e) {
        e.item.row.isSent = !e.item.row.isSent;
        self.checkAll();
    },
    imageEdit: function imageEdit(e) {
        modals.create('order-edit-modal', {
            type: 'modal-primary',
            item: e.item.row,
            images: opts.images,
            submit: function submit() {
                e.item.row = this.item;
                this.modalHide();
                self.update();
            }
        });
    },
    orderItemsShow: function orderItemsShow(e) {
        modals.create('order-items-show-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            item: e.item.row,
            submit: function submit(e) {
                this.modalHide();
            }
        });
    }
};

self.submit = function (e) {
    var params = self.item;
    params.send = self.snd;

    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'Stock',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                self.isNew = false;
                self.update();
                if (self.isNew) riot.route('/orders/stock/' + self.item.id);
                popups.create({ title: 'Успех!', text: 'Предзаказ сохранен!', style: 'popup-success' });
                //observable.trigger('stock-reload')
            }
        });
    }
};

self.reload = function (e) {
    observable.trigger('stock-edit', self.item.id);
};

self.on('mount', function () {
    riot.route.exec();
});
});
riot.tag2('order-items-show-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Состав заказа №{item.idOrder}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <div class="well well-sm">\n            <catalog-static name="items" rows="{item.items}" cols="{parent.itemsCols}" remove-toolbar="1">\n              <yield to="body">\n                <datatable-cell name="article">{row.article}</datatable-cell>\n                <datatable-cell name="name">{row.name}</datatable-cell>\n                <datatable-cell name="nameBrand">{row.nameBrand}</datatable-cell>\n                <datatable-cell name="count">{row.count}</datatable-cell>\n                <datatable-cell name="price">{row.price}</datatable-cell>\n                <datatable-cell name="discount">{row.discount}</datatable-cell>\n                <datatable-cell name="amount">{(row.count * (row.price - row.discount)).toFixed(2).toLocaleString()}</datatable-cell>\n              </yield>\n            </catalog-static>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    self.update();
});

self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'count', value: 'Кол-во' }, { name: 'price', value: 'Цена' }, { name: 'discount', value: 'Скидка' }, { name: 'amount', value: 'Сумма' }];
});
riot.tag2('order-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Настроить заказ</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-images name="images" value="{item.images}" section="orders" hidecatalog="true"></product-edit-images>\n          </div>\n        </div>\n        <hr>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Комментарий</label>\n              <textarea class="form-control" rows="5" name="commentary" value="{item.commentary}"></textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Применить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    modal.images = opts.images || {};
    self.update();
});
});


// WEBPACK FOOTER //
// ./pages/orders/stock-edit.tag